import { axiosIns } from "../utils";
import { unwrapApiData } from "../utils/backendApi";

const toNumber = (value) => {
  const next = Number(value);
  return Number.isNaN(next) ? 0 : next;
};

const toMonthlyArticles = (value) =>
  Array.isArray(value)
    ? value.map((entry) => ({
        period: String(entry?.period || ""),
        count: toNumber(entry?.count),
      }))
    : [];

const toUsersByType = (value) =>
  Array.isArray(value)
    ? value.map((entry) => ({
        userType: String(entry?.userType || entry?.user_type || "unknown"),
        count: toNumber(entry?.count),
      }))
    : [];

const toCategoriesStats = (value) =>
  Array.isArray(value)
    ? value.map((entry) => ({
        category_id: entry?.category_id,
        category_name: String(entry?.category_name || ""),
        user_type: entry?.user_type || null,
        nb_users: toNumber(entry?.nb_users),
        nb_certified: toNumber(entry?.nb_certified),
        subcategories: Array.isArray(entry?.subcategories)
          ? entry.subcategories.map((sub) => ({
              subcategory_id: sub?.subcategory_id,
              subcategory_name: String(sub?.subcategory_name || ""),
              nb_users: toNumber(sub?.nb_users),
            }))
          : [],
      }))
    : [];

export const fetchDashboard = async () => {
  const res = await axiosIns.get("/dashboard/");
  const data = unwrapApiData(res?.data ?? res) || {};
  const validatedArticles = toNumber(
    data?.articles_by_validation?.validated ?? data?.nb_articles_validated,
  );
  const pendingArticles = toNumber(
    data?.articles_by_validation?.pending ?? data?.nb_articles_unvalidated,
  );

  return {
    nb_articles: toNumber(data?.nb_articles),
    nb_articles_validated: toNumber(data?.nb_articles_validated),
    nb_articles_unvalidated: toNumber(data?.nb_articles_unvalidated),
    nb_users: toNumber(data?.nb_users),
    nb_admin: toNumber(data?.nb_admin),
    nb_professional: toNumber(data?.nb_professional),
    nb_expert_users: toNumber(data?.nb_expert_users),
    nb_commite: toNumber(data?.nb_commite),
    nb_particular: toNumber(data?.nb_particular),
    articles_by_month: toMonthlyArticles(data?.articles_by_month),
    users_by_type: toUsersByType(data?.users_by_type),
    articles_by_validation: {
      validated: validatedArticles,
      pending: pendingArticles,
    },
    categories_stats: toCategoriesStats(data?.categories_stats),
  };
};
